import axiosInstance from 'helpers/axiosInstance';

import { Patient } from './patients.type';

export interface CreateOrUpdateMemberResponse {
  patient: Patient;
  patientConsultId: string;
}

export const createOrUpdatePatient = async (
  patientId: string | string[] | undefined,
  patient: Partial<Patient>,
) => {
  const url = `/patients/patients${patientId ? `/${patientId}` : ''}`;

  return axiosInstance
    .post<CreateOrUpdateMemberResponse>(url, patient)
    .then(r => r.data);
};

export const updateNpTeenConsent = async (
  patientId: string | string[] | undefined,
  patient: Partial<Patient>,
) => {
  const url = `/patients/patients${patientId ? `/${patientId}` : ''}`;

  return axiosInstance
    .patch<CreateOrUpdateMemberResponse>(url, { patient: patient })
    .then(r => r.data);
};
